import styles from './PendingToRedeem.module.css';
import iconPontosPendentes from '../../../../assets/images/icon-pontos-pendentes.png';
import { numberWithCommas } from '../../../../utils/numberWithCommas';
import { Card } from '../../../../components/Card';
import { useAuth } from '../../../../hooks/useAuth';
import { useTransaction } from '../../../../hooks/useTransaction';
import { useEffect } from 'react';

export function PendingToRedeem() {
  const { client } = useAuth();
  const { getLastTransaction, lastTransaction } = useTransaction();

  useEffect(() => {
    getLastTransaction('PENDING_POINTS');
  }, []);

  return (
    <div className="col-sm-12 col-md-6 col-lg-3 d-flex pb-3">
      <Card
        style={{
          height: '130px',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="d-flex align-items-center">
          <img
            className={`me-3 ${styles.icon}`}
            src={iconPontosPendentes}
            alt="moeda"
          />
          <div className="d-block">
            <p className="m-0 tiny-text">Pendentes</p>
            <p className="m-0 fs-4 fw-semibold">
              {lastTransaction
                ? numberWithCommas(lastTransaction.balance.toFixed(2))
                : numberWithCommas((0).toFixed(2))}{' '}
              <span className="tiny-text">
                {lastTransaction?.balance === 1 ? (
                  <span>{`${client?.coinName ? client.coinName.replace(/\(\w*\)/g, '') : 'ponto'}`}</span>
                ) : (
                  <span>{`${client?.coinName ? client.coinName.replace(/\((\w+)\)/, (_, conteudo) => conteudo) : 'pontos'}`}</span>
                )}
              </span>
            </p>
          </div>
        </div>
      </Card>
    </div>
  );
}
